import { render, staticRenderFns } from "./material-list.vue?vue&type=template&id=3b1e53e5&scoped=true&"
import script from "./material-list.vue?vue&type=script&lang=ts&"
export * from "./material-list.vue?vue&type=script&lang=ts&"
import style0 from "./material-list.vue?vue&type=style&index=0&id=3b1e53e5&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e53e5",
  null
  
)

export default component.exports